import { Deserializable } from '../deserializable';

export class FiaLeftToApplyFor implements Deserializable {
  public amount: number;
  public message: string;
  public fiaAvailable: number;
  public sdaAvailable: number;
  public totalAmountRequested: number;
  public pinTotalAvailableBalance: number;
  public pendingAppCount: number;
  public totalAppliedForCurrentYear: number;
  public maxTradeAmount: number;
  public bankBalance: number;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
